import React, { useEffect, useState } from 'react';
import { usePreferences } from '../state/usePreferences';

// Same brief the page already loaded, so the card costs no request.
const remainingFrom = (locksAt) => {
  const at = locksAt ? new Date(locksAt).getTime() : 0;
  if (!at || Number.isNaN(at)) return 0;
  return Math.max(0, at - Date.now());
};

const parts = (ms) => {
  const total = Math.max(0, Math.floor(ms / 1000));
  return {
    days: Math.floor(total / 86400),
    hours: Math.floor((total % 86400) / 3600),
    minutes: Math.floor((total % 3600) / 60),
    seconds: total % 60,
  };
};

const pad = (n) => String(n).padStart(2, '0');

// Minutes are the finest unit here: the card is read once, not watched.
const longForm = ({ days, hours, minutes, seconds }) => {
  if (days > 0) return `${days}d ${pad(hours)}h ${pad(minutes)}m`;
  if (hours > 0) return `${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
  return `${pad(minutes)}m ${pad(seconds)}s`;
};

const shortForm = ({ days, hours, minutes }) => {
  if (days > 0) return `${days}d`;
  if (hours > 0) return `${hours}h`;
  return `${minutes}m`;
};

/**
 * The deadline on phone, where the header row is hidden and the booking name
 * has nowhere else to go. The same numbers the band shows on a laptop.
 */
const DeadlineCard = () => {
  const { locksAt, closed, bookingName } = usePreferences();
  const [remaining, setRemaining] = useState(() => remainingFrom(locksAt));

  useEffect(() => {
    if (!locksAt || remainingFrom(locksAt) <= 0) {
      setRemaining(0);
      return undefined;
    }
    const timer = setInterval(() => {
      const left = remainingFrom(locksAt);
      setRemaining(left);
      if (left <= 0) clearInterval(timer);
    }, 1000);
    return () => clearInterval(timer);
  }, [locksAt]);

  // A closed form explains itself in its own banner.
  if (!locksAt || closed || remaining <= 0) return null;

  const split = parts(remaining);

  return React.createElement(
    'div',
    { className: 'cp-dcard' },
    React.createElement('span', { className: 'cp-dcard-chip' }, shortForm(split)),
    React.createElement(
      'span',
      { className: 'cp-dcard-text' },
      bookingName
        ? React.createElement('span', { className: 'cp-dcard-name' }, bookingName)
        : null,
      React.createElement(
        'span',
        { className: 'cp-dcard-meta' },
        `Form closes in ${longForm(split)}`
      )
    )
  );
};

export default DeadlineCard;
